import React, { useEffect, useState } from 'react';
import CustomDialog from '../../shared/Overlays/CustomDialog';
import { useDispatch, useSelector } from 'react-redux';
import { addTaskAction, editTaskAction, getTaskAction } from '../../redux/actions/CheckIn/CheckIn';
import { DataView } from 'primereact/dataview';
import { CustomCalenderInput, CustomCheckbox, CustomDropDown, CustomInput, CustomTextArea } from '../../shared/Input/AllInputs';
import { formatLetter, dateConversions, showFormErrors } from '../../utils/commonFunctions';
import { CustomGridLayout } from '../../shared/Cards/CustomCard';
import useEmployees from '../../hooks/Employees/useEmployees';
import { taskTypeOptions } from '../../utils/dropdownConstants';
import formValidation from '../../utils/validations';
import useMembers from '../../hooks/Members/useMembers';
import { getTasks } from '../../redux/actions/MembersPortal/memberPortalActions';

const Task = ({ openTask, setOpenTask }) => {
    const dispatch = useDispatch();
    const [showCreateTaskPopup, setShowCreateTaskPopup] = useState(false);
    const [loading, setLoading] = useState(false);

    const initialState = {
        member: '',
        dueDate: new Date(),
        taskType: '',
        taskTitle: '',
        message: '',
        employee: '',
    };
    const [data, setData] = useState(initialState);
    const { employeesDropdown } = useEmployees();
    const { allMembersDropdown } = useMembers();

    useEffect(() => {
        dispatch(getTaskAction());
    }, [dispatch]);

    let task = useSelector((state) => state?.checkin?.task);

    const handleEditStatus = (id, active) => {
        task = task?.map((item) => {
            if (item._id === id) {
                dispatch(editTaskAction(item?._id, { status: active ? 'COMPLETED' : 'PENDING' }));
                return { ...item, status: 'COMPLETED' };
            } else {
                return { ...item, status: 'PENDING' };
            }
        });
    };

    const itemTemplate = (item, index) => {
        return (
            <div className="col-12 grid py-2  " key={item?._id}>
                <div className="col-1 my-auto">
                    <CustomCheckbox name="status" col="4" checked={item?.status === 'COMPLETED'} onChange={(e) => handleEditStatus(item._id, e.value)} />
                </div>
                <div className="col-10">{renderRow(item, index)}</div>
            </div>
        );
    };

    const renderRow = (item, index) => {
        return (
            <div className="flex">
                <div className="mx-3 flex w-5">
                    <div className="mx-3">
                        <div className="font-medium ">Deadline</div>
                        <div>{dateConversions(item.dueDate)}</div>
                    </div>
                </div>
                <div className="mx-3">
                    <div className="font-medium ">Task Title</div>
                    <div>{item?.taskTitle}</div>
                </div>
                <div className="mx-3">
                    <div className="font-medium ">Task Type</div>
                    <div>{formatLetter(item?.taskType)}</div>
                </div>
                <div className="mx-3">
                    <div className="font-medium ">Member</div>
                    <div>{item?.member}</div>
                </div>
            </div>
        );
    };

    const onCreateTask = () => {
        setOpenTask(false);
        setShowCreateTaskPopup(true);
    };

    const handleChange = ({ name, value }) => {
        const formErrors = formValidation(name, value, data);
        setData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    const handleSave = () => {
        if (showFormErrors(data, setData)) {
            dispatch(
                addTaskAction(data, setLoading, () => {
                    setOpenTask(false);
                    setData(initialState);
                    dispatch(getTaskAction());
                    setShowCreateTaskPopup(false);
                    setOpenTask(true);
                }),
            );
        }
    };

    return (
        <div>
            {showCreateTaskPopup && (
                <>
                    <CustomDialog
                        title="Add Task"
                        visible={showCreateTaskPopup}
                        onCancel={() => {
                            setShowCreateTaskPopup(false);
                            setData(initialState);
                        }}
                        loading={loading}
                        onSave={handleSave}
                        width="60vw"
                    >
                        <CustomGridLayout>
                            <CustomDropDown name="member" onChange={handleChange} data={data} options={allMembersDropdown} col="12" />
                            <CustomCalenderInput name="dueDate" label="Deadline" data={data} onChange={handleChange} col="6" minDate={new Date()} />
                            <CustomDropDown name="taskType" onChange={handleChange} data={data} options={taskTypeOptions} col="6" />
                            <CustomDropDown name="employee" onChange={handleChange} data={data} options={employeesDropdown} col="6" />
                            <CustomInput name="taskTitle" onChange={handleChange} data={data} col="6" />
                            <CustomTextArea name="message" onChange={handleChange} data={data} />
                        </CustomGridLayout>
                    </CustomDialog>
                </>
            )}
            <CustomDialog
                title="Task"
                visible={openTask}
                onCancel={() => {
                    setOpenTask(false);
                }}
                loading={false}
                onSave={onCreateTask}
                saveLabel="Create Task"
                width="60vw"
            >
                <DataView value={task} itemTemplate={itemTemplate} paginator rows={5} />
            </CustomDialog>
        </div>
    );
};

export default Task;
